import type { ReactNode } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { ACTIONS_COLUMN_ID } from './dataTable.constants';

const ACTIONS_COLUMN_HEADER = 'Actions';

export function createActionsColumn<TData>(
  renderActions: (item: TData) => ReactNode,
): ColumnDef<TData, unknown> {
  return {
    id: ACTIONS_COLUMN_ID,
    header: ACTIONS_COLUMN_HEADER,
    cell: ({ row }) => renderActions(row.original),
  };
}
